import { PhoneField, validatePhoneNumber } from '@boltenergy-be/design-system'
import { Controller, useFormContext } from 'react-hook-form'
import { PhoneProps } from 'components/inputs/phone/types'
import { useTranslation } from 'next-i18next/pages'
import { getFieldName } from 'components/inputs/utils'

const Phone = ({ required = true, invalidErrorText, parentDotPath, identifier = 'mobilePhone', label, ...props }: PhoneProps) => {
  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  // Constants
  const fieldKey = getFieldName(identifier, parentDotPath)

  // React Hook Form
  const { register, control } = useFormContext()

  return (
    <Controller
      {...{ control }}
      name={fieldKey}
      render={({ field, fieldState }) => (
        <PhoneField
          {...props}
          {...register(fieldKey, {
            required: required ? t('validation:required') : false,
            validate: (value: string) => {
              if (!required && !value) return true
              return validatePhoneNumber(value || '').valid || invalidErrorText || t('commonFormFields:phone.errors.invalid')
            }
          })}
          value={field.value}
          label={label || t('commonFormFields:phone.label')}
          onChange={field.onChange}
          error={fieldState?.error?.message}
          {...(!required && { optionalText: t('common:optional') })}
        />
      )}
    />
  )
}

export default Phone
